import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=710ecf94&"
import script from "./transfer.vue?vue&type=script&lang=ts&"
export * from "./transfer.vue?vue&type=script&lang=ts&"
import style0 from "./transfer.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports